module.exports = __webpack_public_path__ + "img/pop_white_L.bb155cf0.png";